<accordion [isAnimated]="true">
    <form class="form-horizontal" [formGroup]="personAddressInformationForm">
    <accordion-group [isOpen]="true">
      <span accordion-heading>
        <i class='fa fa-map-marker'></i> Información de Ubicación
      </span>
      <div class="form-group row">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Vivienda</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="homeType"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <ng-select formControlName="homeType" [items]="homeTypes" bindLabel="value" bindValue="key" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Vive desde</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="liveFromDate"></span>
      </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input bsDatepicker class="form-control" formControlName="liveFromDate" [ngClass]="personAddressInformationForm.controls.liveFromDate.errors ? 'is-invalid' : 'is-valid'" [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }" [readonly]="readonly">
        </div>
      </div>
      <div class="row">
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Pais</b>
            <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="country"></span>
          </label>
          <ng-select formControlName="country" [items]="nationalities" bindLabel="country" bindValue="code" (change)="changeCountry($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Departamento</b>
            <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="deparment"></span>
          </label>
          <ng-select formControlName="deparment" [items]="departments" bindLabel="name" bindValue="region" (change)="changeDepartment($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Ciudad</b>
            <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="city"></span>
          </label>
          <ng-select formControlName="city" [items]="cities" bindLabel="name" bindValue="cityCode" (change)="changeCity($event)" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
        <div class="form-group col-md-3">
          <label class="col-form-label"><b>Colonia</b>
            <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="neighborhood"></span>
          </label>
          <ng-select formControlName="neighborhood" [items]="neighborhoods" bindLabel="name" bindValue="code" [clearable]="false" [readonly]="readonly"></ng-select>
        </div>
      </div>
      <div class="form-group row" *ngIf="!hideStreeFields">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 1</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="street"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street" [ngClass]="personAddressInformationForm.controls.street.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row" *ngIf="!hideStreeFields && !isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 2</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="street2"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street2" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row" *ngIf="!hideStreeFields && !isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 3</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="street3"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street3">
        </div>
      </div>
      <div class="form-group row" *ngIf="!hideStreeFields && !isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 4</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="street4"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street4" [readonly]="readonly">
        </div>
      </div>
      <div class="form-group row" *ngIf="!hideStreeFields && !isShortFormActiveForPlan">
        <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 5</b>
          <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="street5"></span>
        </label>
        <div class="col-10 col-md-10 col-sm-8 ">
          <input type="text" class="form-control" formControlName="street5" [readonly]="readonly">
        </div>
      </div>
    </accordion-group>
    <accordion-group [isOpen]="true">
        <span accordion-heading>
          <i class='fa fa-phone'></i> Información de Teléfonos
        </span>

        <div class="row">
          <div class="form-group col-md-3">
            <label class="col-form-label"><b>Tipo de Telefono</b>
            </label>
            <input type="text" class="form-control" value="Celular" disabled>
          </div>
          <div class="form-group col-md-9">
            <label class="col-form-label"><b>Teléfono</b>
              <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="mobilePhone"></span>
            </label>
            <input type="text" class="form-control" formControlName="mobilePhone" [ngClass]="personAddressInformationForm.controls.mobilePhone.errors ? 'is-invalid' : 'is-valid'" [mask]="currentMask" [showMaskTyped]="true" [readonly]="readonly">
          </div>
        </div>
        <div class="row" *ngIf="!isShortFormActiveForPlan">
          <div class="form-group col-md-3">
            <label class="col-form-label"><b>Tipo de Telefono</b>
            </label>
            <input type="text" class="form-control" value="Casa" disabled>
          </div>
          <div class="form-group col-md-9">
            <label class="col-form-label"><b>Teléfono</b>
              <span appRequiredAsterisk [formGroup]="personAddressInformationForm" controlName="phone"></span>
            </label>
            <input type="text" class="form-control" formControlName="phone" [mask]="currentMask" [showMaskTyped]="true" [readonly]="readonly">
          </div>
        </div>
      </accordion-group>
</form>
</accordion>